import {fetchFor, responseToJson} from '@sinclair-digital/sbg-util/dist/es/fetch';

const {localStorage} = window;

const isStorylineUrl = (url) => {
    const {hostname} = new URL(url, 'https://sinclairstoryline.com/');
    return hostname.includes('sinclairstoryline.com');
};

const getAuthHeaders = (tokenName) => {
    const accessToken = localStorage.getItem(tokenName);
    return accessToken ? {
        'Authorization': `Bearer ${accessToken}`,
    } : {};
};

const fetchJson = (url, options = {}) => {
    if (!isStorylineUrl(url)) {
        console.error('Only Storyline requests should be made using fetchAuthorized.');
        return Promise.reject(new Error('Not a Storyline request'));
    }

    return fetchFor('application/json', responseToJson)(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });
};

// all requests to Storyline V1 (News Publishing) go through fetchV1 / fetchJsonV1 / jQueryFetchJsonV1
export const fetchV1 = (accept, extract) => (url, options = {}) =>
    fetchFor(accept, extract)(url, {
        ...options,
        headers: {
            ...getAuthHeaders('auth0AccessTokenV1'),
            ...options.headers,
        },
    });

export const fetchJsonV1 = (url, options = {}) =>
    fetchJson(url, {
        ...options,
        headers: {
            ...getAuthHeaders('auth0AccessTokenV1'),
            ...options.headers,
        },
    });

export const jQueryFetchJsonV1 = ($) => (opts = {}) => $.ajax({
    timeout: 60000,
    dataType: 'json',
    cache: false,
    async: true,
    contentType: 'application/json',
    global: true,
    ifModified: opts.mod ? opts.mod : false,
    processData: true,
    password: '',
    username: '',
    beforeSend: opts.before || $.noop,
    ...opts,
    headers: {
        ...getAuthHeaders('auth0AccessTokenV1'),
        ...opts.headers,
    },
});

// all requests to Storyline V2 (OTT) go through here
export const fetchJsonV2 = (url, options = {}) =>
    fetchJson(url, {
        ...options,
        headers: {
            'X-Track-CorrelationToken': localStorage.getItem('X-Track-CorrelationToken') || '',
            ...getAuthHeaders('auth0AccessTokenV2'),
            ...options.headers,
        },
    });
